/**
 * Tax Type API Service
 * Service layer for tax type-related API calls
 */

import apiClient from './axios.config';
import type { TaxTypesResponse } from '@/types/api/taxType';

/**
 * Tax Type API service object
 */
export const taxTypeApi = {
  /**
   * GET /api/tax-types
   * Get tax types by country code (ISO 3166-1 alpha-2, e.g. "TW").
   * The endpoint requires `countryCode` — sending `countryId` is a 400
   * on both the backend and the MSW mock (drift D-REF-1).
   */
  getByCountry: async (countryCode: string): Promise<TaxTypesResponse> => {
    const response = await apiClient.get<TaxTypesResponse>('/tax-types', {
      params: { countryCode },
    });
    return response.data;
  },
};

export default taxTypeApi;
